import { CreatePathResult } from 'utils/routes/types';

export function getLinkProps(pathConfig?: CreatePathResult) {
  if (!pathConfig) {
    return undefined;
  }

  return { to: pathConfig[0], ...pathConfig[1] };
}
